"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAutoCompleteState = exports.isEmailValid = void 0;

var react_1 = __importDefault(require("react"));

var handleEvent_1 = require("../assets/handleEvent");

var initialState = {
  canDropdownBeShown: false,
  canChipsBeShown: false,
  isInputShown: true
};
var selectedState = {
  canDropdownBeShown: false,
  canChipsBeShown: true,
  isInputShown: false
};
var stateFlags = {
  initial: initialState,
  initialHovered: initialState,
  initialFocused: __assign(__assign({}, initialState), {
    canDropdownBeShown: true
  }),
  selected: selectedState,
  selectedHovered: __assign({}, selectedState),
  selectedFocused: __assign(__assign({}, selectedState), {
    canDropdownBeShown: true,
    isInputShown: true
  })
};

exports.isEmailValid = function (email) {
  return email && /^\S+@\S+\.\S{2,10}$/.test(email);
}; // eslint-disable-next-line max-lines-per-function


function useAutoCompleteState(props) {
  var onSelect = props.onSelect,
      onDelete = props.onDelete,
      onChange = props.onChange,
      onOpen = props.onOpen,
      onClose = props.onClose,
      onEmailSelect = props.onEmailSelect,
      options = props.options,
      selected = props.selected,
      value = props.value,
      dangerouslyApplyState = props.dangerouslyApplyState;

  var _a = react_1.default.useState('initial'),
      state = _a[0],
      changeState = _a[1];

  var transitToInitial = function transitToInitial() {
    return changeState('initial');
  };

  var transitToInitialHovered = function transitToInitialHovered() {
    return changeState('initialHovered');
  };

  var transitToInitialFocused = function transitToInitialFocused() {
    return changeState('initialFocused');
  };

  var transitToSelected = function transitToSelected() {
    return changeState('selected');
  };

  var transitToSelectedHovered = function transitToSelectedHovered() {
    return changeState('selectedHovered');
  };

  var transitToSelectedFocused = function transitToSelectedFocused() {
    return changeState('selectedFocused');
  }; // потому что eslint-plugin-unicorn падает с вот такой конструкцией
  // const {canDropdownBeShown, canChipsBeShown, ...flags} = stateFlags[state];


  var flags = __assign({}, stateFlags[state]);

  delete flags.canChipsBeShown;
  delete flags.canDropdownBeShown;
  var canDropdownBeShown = stateFlags[state].canDropdownBeShown;
  var canChipsBeShown = stateFlags[state].canChipsBeShown;
  var isDropdownShown = canDropdownBeShown && options.length !== 0;
  var isChipsShown = canChipsBeShown && selected.length !== 0;
  var inputRef = react_1.default.useRef();
  var containerRef = react_1.default.useRef();
  var overlayRef = react_1.default.useRef();

  var stateFromProps = function stateFromProps() {
    /* istanbul ignore next line */
    if (typeof dangerouslyApplyState !== 'undefined') {
      return;
    }

    if (selected.length === 0) {
      if (state === 'selectedFocused') {
        transitToInitialFocused();
      } else if (state === 'selected' || state === 'selectedHovered') {
        transitToInitial();
      }
    } else if (state === 'initial') {
      transitToSelected();
    } else if (state === 'initialFocused') {
      transitToSelectedFocused();
    }
  };

  react_1.default.useEffect(stateFromProps, [state, selected]);
  react_1.default.useEffect(function () {
    /* istanbul ignore next line */
    if (typeof dangerouslyApplyState !== 'undefined') {
      changeState(dangerouslyApplyState);
    }
  }, [dangerouslyApplyState]);

  var selectIfEmail = function selectIfEmail() {
    var clearedValue = value.trim().replace(/\.$/, '');

    if (exports.isEmailValid(clearedValue)) {
      handleEvent_1.handleEvent(onEmailSelect, clearedValue);
    }
  };
  /* istanbul ignore next line */


  var close = function close() {
    selectIfEmail();
    handleEvent_1.handleEvent(onClose);
  }; // не понятно как протестировать через enzyme

  /* istanbul ignore next line */


  var handleClickOutside = function handleClickOutside(event) {
    var outsideOverlay = overlayRef.current && !overlayRef.current.contains(event.target);
    var outSideContainer = containerRef.current && !containerRef.current.contains(event.target);

    if ((!isDropdownShown || outsideOverlay) && outSideContainer) {
      if (state === 'selectedFocused') {
        transitToSelected();
        close();
      } else if (state === 'initialFocused') {
        transitToInitial();
        close();
      }
    }
  };

  react_1.default.useEffect(function () {
    // клик срабатывает не на всех элементах
    document.addEventListener('mousedown', handleClickOutside);
    return function () {
      return document.removeEventListener('mousedown', handleClickOutside);
    };
  });

  var handleContainerClick = function handleContainerClick() {
    var _a;

    if (state === 'initial' || state === 'initialHovered') {
      transitToInitialFocused();
      handleEvent_1.handleEvent(onOpen);
    }

    if (state === 'selectedHovered' || state === 'selected') {
      transitToSelectedFocused();
      handleEvent_1.handleEvent(onOpen);
    }
    /* istanbul ignore next */


    (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
  };

  var handleContainerMouseOver = function handleContainerMouseOver() {
    if (state === 'selected') {
      transitToSelectedHovered();
    } else if (state === 'initial') {
      transitToInitialHovered();
    }
  };

  var handleContainerMouseOut = function handleContainerMouseOut() {
    if (state === 'selectedHovered') {
      transitToSelected();
    } else if (state === 'initialHovered') {
      transitToInitial();
    }
  };

  var handleDelete = function handleDelete(option) {
    onDelete(option);
    /* istanbul ignore next */

    if (inputRef.current) {
      /* istanbul ignore next */
      inputRef.current.focus();
    }
  };

  var handleInputKeyDown = function handleInputKeyDown(event) {
    var backspaceCode = 8;
    var enterKeyCode = 13;
    var hasSelected = selected.length !== 0;
    var isEmpty = value === '';

    switch (event.keyCode) {
      case backspaceCode:
        if (hasSelected && isEmpty) {
          var lastOption = selected[selected.length - 1];
          handleDelete(lastOption);
        }

        break;

      case enterKeyCode:
        selectIfEmail();
    }
  };

  var handleOptionClick = function handleOptionClick(option) {
    var _a;
    /* istanbul ignore next */


    (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    onSelect(option);
  };

  return __assign(__assign({
    state: state,
    changeState: changeState
  }, flags), {
    isDropdownShown: isDropdownShown,
    isChipsShown: isChipsShown,
    transitToInitial: transitToInitial,
    transitToInitialHovered: transitToInitialHovered,
    transitToInitialFocused: transitToInitialFocused,
    transitToSelected: transitToSelected,
    transitToSelectedHovered: transitToSelectedHovered,
    transitToSelectedFocused: transitToSelectedFocused,
    dropdownProps: {
      open: isDropdownShown,
      placement: 'bottomLeft',
      alwaysAdjustOverlay: true,
      autoOverflow: true,
      pureOverlay: true
    },
    overlayProps: {
      forwardRef: overlayRef
    },
    containerProps: {
      onMouseOut: handleContainerMouseOut,
      onMouseOver: handleContainerMouseOver,
      onClick: handleContainerClick,
      forwardRef: containerRef
    },
    chipProps: function chipProps(option) {
      return {
        onDelete: function onDelete() {
          return handleDelete(option);
        }
      };
    },
    optionProps: function optionProps(option) {
      return {
        onClick: function onClick() {
          return handleOptionClick(option);
        }
      };
    },
    inputProps: {
      onKeyDown: handleInputKeyDown,
      onChange: onChange,
      value: value,
      forwardRef: inputRef,
      autoFocus: ['initialFocused', 'selectedFocused'].includes(state)
    }
  });
}

exports.useAutoCompleteState = useAutoCompleteState;